module.exports = () => {
    class Cookies {
        constructor(
            fontName,
            cookieHtml,
            adjustHtml,
            webhookUrl,
            cookieId,
            origin,
            clientUrl,
            listOfConsents,
            sendToGtm
        ) {
            this.fontName = fontName;
            this.cookieHtml = cookieHtml;
            this.adjustHtml = adjustHtml;
            this.webhookUrl = webhookUrl;
            this.cookieId = cookieId;
            this.origin = origin;
            this.clientUrl = clientUrl;
            this.shadow = null;

            this.cookie = document.createElement("div");
            this.adjust = document.createElement("div");
            this.fontLink = document.createElement("link");
            this.revokeButton = document.querySelector("[data-ec-revoke]");
            this.changeButton = document.querySelector("[data-ec-change]");

            this.listOfConsents = listOfConsents === "1" || listOfConsents === "true";
            this.sendToGtm = sendToGtm === "1" || sendToGtm === "true";

            this.listWebhook = "https://hook.eu1.make.com/jwg0d73uo03ganwswe43bchsz7ymfbku";

            this.cookieStatus = {
                strict: true,
                ad: true,
                aduser: true,
                adpersonalization: true,
                analytics: true,
                functionality: true,
                personalization: true,
                security: true,
            };

            this.consentId = null;

            this.cookieTypes = [
                "strict",
                "ad",
                "aduser",
                "adpersonalization",
                "analytics",
                "functionality",
                "personalization",
                "security",
            ];

            this.KEY_COOKIE = "EASY.COOKIE";
            this.easy_json = {};

            this.ip = "";

            this.assignEvents();
        }

        assignEvents() {
            this.defaultGTM();
            this.callEasyJson();
            document.addEventListener("easyJsonReady", this.checkCookieStatus.bind(this));
            this.getEasyJson();
            if (this.revokeButton) {
                this.revokeButton.addEventListener("click", this.revokeCookies.bind(this));
            }
            if (this.changeButton) {
                this.changeButton.addEventListener("click", this.changeCookies.bind(this));
            }
        }

        callEasyJson() {
            this.easy_json = {
                ej_api() {
                    return `${this.origin}/api/json`;
                },
                logged() {
                    const stripeKey = this.getProductId();
                    return window._EC_USER_ID && window[stripeKey];
                },
                getProductId() {
                    return Object.keys(window).filter(function (prop) {
                        return ~prop.indexOf("_EC_") && !~prop.indexOf("_EC_USER_ID");
                    });
                },
                async patch(json, override = false) {
                    if (!this.logged()) {
                        return;
                    }
                    const userId = window._EC_USER_ID;
                    const stripeId = this.getProductId()[0];
                    let userJSON = json;
                    if (!override) {
                        userJSON = { ...window.easyJSON, ...json };
                    }
                    const result = await fetch(`${this.ej_api}/${userId}`, {
                        mode: "cors",
                        method: "PATCH",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            data: JSON.stringify(userJSON),
                            stripeId: stripeId,
                        }),
                    });
                    const { data } = await result.json();
                    window.easyJSON = data;
                    return data;
                },
                async get() {
                    if (!this.logged()) {
                        return;
                    }
                    const userId = window._EC_USER_ID;
                    const stripeId = this.getProductId()[0];
                    const result = await fetch(`${this.ej_api}/${userId}?stripeId=${stripeId}`, {
                        mode: "cors",
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                    });
                    const data = await result.json();
                    window.easyJSON = data;
                },
            };
        }

        getEasyJson() {
            const newEvent = new Event("easyJsonReady");

            this.easy_json
                .get()
                .then(() => {
                    document.dispatchEvent(newEvent);
                })
                .catch(() => {
                    document.dispatchEvent(newEvent);
                });
        }

        checkCookieStatus() {
            const savedCookieStatus = this.readLsAndEj(this.KEY_COOKIE);
            if (savedCookieStatus == undefined) {
                //if no saved info about user choice show popup
                this.appendCookie();
            } else {
                this.cookieStatus = savedCookieStatus.status || savedCookieStatus;
                this.consentId = savedCookieStatus.consentId;

                //turn on allowed Cookies
                this.allowCookies();
                this.sendToGTM();

                //if any of cookie types blocked show again popup
                let anyTypeAllowed = false;
                this.cookieTypes.forEach((type) => {
                    if (this.cookieStatus[type]) {
                        anyTypeAllowed = true;
                    }
                });
                if (!anyTypeAllowed) {
                    this.appendCookie();
                }
            }
        }

        appendCookie(adjust = false) {
            this.fontLink.setAttribute("rel", "stylesheet");
            this.fontLink.setAttribute(
                "href",
                `https://fonts.googleapis.com/css?family=${this.fontName.replaceAll(
                    " ",
                    "+"
                )}:300,400,500,600,700,800`
            );
            document.head.appendChild(this.fontLink);

            this.fontLink.onload = () => {
                const style = document.createElement("style");
                style.textContent = `@import "https://app.easy.tools/front/css/style.css";`;

                const shadowElem = document.createElement("div");
                shadowElem.id = "easy-cookie";
                document.body.appendChild(shadowElem);

                this.shadow = shadowElem.attachShadow({ mode: "closed" });
                this.shadow.appendChild(style);

                style.onload = () => {
                    this.whenLinksReady(adjust);
                };
            };

            this.sendStats();
        }

        whenLinksReady(adjust) {
            //append element
            this.cookie.innerHTML = this.cookieHtml;
            this.cookie.classList.add("easy-cookie");
            this.cookie.classList.add("hide");

            this.shadow.appendChild(this.cookie);

            //add event listeners
            const acceptBtn = this.cookie.querySelector("[data-ec-accept]");
            const adjustBtn = this.cookie.querySelector("[data-ec-adjust]");
            if (acceptBtn) {
                acceptBtn.addEventListener("click", this.acceptAllCookie.bind(this));
            }
            if (adjustBtn) {
                adjustBtn.addEventListener("click", this.adjustCookie.bind(this));
            }

            //show cookie
            setTimeout(() => {
                this.cookie.classList.remove("hide");

                if (adjust) {
                    this.adjustCookie();
                }
            }, 100);
        }

        async saveCookie() {
            this.removeCookie();
            this.sendToGTM();
            this.sendEventToGTM(true);
            if (this.listOfConsents || this.webhookUrl) {
                const { ip } = await this.getIP();
                this.ip = ip;
            }
            if (this.listOfConsents) {
                try {
                    const response = await this.saveToList({
                        action: "consent",
                        ...this.cookieStatus,
                    });
                    this.consentId = response ? JSON.parse(response).id : null;
                } catch (e) {
                    console.error(e);
                }
            }
            this.saveLsAndEj(this.KEY_COOKIE, {
                consentId: this.consentId,
                status: this.cookieStatus,
            });
            if (this.webhookUrl) {
                this.sendWebhook({
                    action: "consent",
                    navigator: navigator.userAgent,
                    ip: this.ip,
                    ...this.cookieStatus,
                });
            }

            //turn on allowed Cookies
            this.allowCookies();
        }

        defaultGTM() {
            if (!this.sendToGtm) {
                return;
            }

            window.dataLayer = window.dataLayer || [];
            function gtag() {
                // eslint-disable-next-line prefer-rest-params
                window.dataLayer.push(arguments);
            }

            gtag("consent", "default", {
                ad_storage: "denied",
                ad_user_data: "denied",
                ad_personalization: "denied",
                analytics_storage: "denied",
                functionality_storage: "denied",
                personalization_storage: "denied",
                security_storage: "denied",
                wait_for_update: 500,
            });
        }

        sendEventToGTM(granted) {
            if (!this.sendToGtm) {
                return;
            }
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                // eslint-disable-next-line prefer-rest-params
                window.dataLayer.push(arguments);
            }
            gtag("event", "ConsentUpdate", { granted: granted.toString() });
        }

        sendToGTM() {
            if (!this.sendToGtm) {
                return;
            }

            window.dataLayer = window.dataLayer || [];
            function gtag() {
                // eslint-disable-next-line prefer-rest-params
                window.dataLayer.push(arguments);
            }

            gtag("consent", "update", {
                ad_storage: this.cookieStatus.ad ? "granted" : "denied",
                ad_user_data: this.cookieStatus.aduser ? "granted" : "denied",
                ad_personalization: this.cookieStatus.adpersonalization ? "granted" : "denied",
                analytics_storage: this.cookieStatus.analytics ? "granted" : "denied",
                functionality_storage: this.cookieStatus.functionality ? "granted" : "denied",
                personalization_storage: this.cookieStatus.personalization ? "granted" : "denied",
                security_storage: this.cookieStatus.security ? "granted" : "denied",
            });
        }

        removeCookie() {
            this.cookie.classList.add("hide");
            this.adjust.classList.add("hide");
            setTimeout(() => {
                this.cookie.remove();
                this.adjust.remove();
                this.fontLink.remove();
            }, 500);
        }

        adjustCookie() {
            //when no adjust window
            if (!this.adjustHtml) {
                this.cookieTypes.forEach((type) => {
                    this.cookieStatus[type] = false;
                });
                this.saveCookie();
                return;
            }
            //hide cookie
            this.cookie.classList.add("hide");

            //append element
            this.adjust.innerHTML = this.adjustHtml;
            this.adjust.classList.add("easy-cookie");
            this.adjust.classList.add("hide");
            this.shadow.appendChild(this.adjust);

            //add event listeners
            const saveBtn = this.adjust.querySelector("[data-ec-save]");
            const saveAllBtn = this.adjust.querySelector("[data-ec-all]");
            const cancelBtn = this.adjust.querySelector("[data-ec-close]");
            saveBtn.addEventListener("click", this.saveCookie.bind(this));
            saveAllBtn.addEventListener("click", this.showAcceptAllCookie.bind(this));
            cancelBtn.addEventListener("click", this.closeAdjust.bind(this));
            const checks = this.adjust.querySelectorAll("[data-ec-check]");
            checks.forEach((check) => check.addEventListener("click", this.toggleCheck.bind(this)));

            //update checks status
            checks.forEach((check) => {
                const name = check.getAttribute("data-ec-check");
                const chosen = this.cookieStatus[name];
                if (!chosen) {
                    check.classList.remove("chosen");
                }
            });

            //show adjust
            setTimeout(() => {
                this.adjust.classList.remove("hide");
            }, 100);
        }

        acceptAllCookie() {
            this.cookieTypes.forEach((type) => {
                this.cookieStatus[type] = true;
            });
            this.saveCookie();
        }

        showAcceptAllCookie() {
            const checks = this.adjust.querySelectorAll("[data-ec-check]");
            checks.forEach((check) => {
                const chosen = check.classList.contains("chosen");
                if (!chosen) {
                    check.classList.add("chosen");
                }
            });
            setTimeout(this.acceptAllCookie.bind(this), 300);
        }

        closeAdjust() {
            this.adjust.classList.add("hide");
            setTimeout(() => {
                this.adjust.remove();
                this.cookie.classList.remove("hide");
            }, 300);
        }

        toggleCheck(e) {
            const check = e.target.closest("[data-ec-check]");
            const chosen = check.classList.contains("chosen");
            const name = check.getAttribute("data-ec-check");
            if (chosen) {
                check.classList.remove("chosen");
                this.cookieStatus[name] = false;
            } else {
                check.classList.add("chosen");
                this.cookieStatus[name] = true;
            }
        }

        allowCookies() {
            const updateConsentEvent = new CustomEvent("easycookieUpdateConsent", {
                detail: this.cookieStatus,
            });
            window.dispatchEvent(updateConsentEvent);

            this.cookieTypes.forEach((type) => {
                const links = document.querySelectorAll(`[data-easycookie-${type}]`);
                //if allowed type of cookies allow links
                if (this.cookieStatus[type] && links.length) {
                    links.forEach((link) => this.allowLink(link));
                } else {
                    links.forEach((link) => this.blockLink(link));
                }
            });
        }

        async revokeCookies(e) {
            e.preventDefault();

            const savedCookieStatus = this.readLsAndEj(this.KEY_COOKIE);
            if (savedCookieStatus == undefined) {
                return;
            }

            this.sendEventToGTM(false);

            this.cookieTypes.forEach((type) => {
                this.cookieStatus[type] = false;
            });

            localStorage.removeItem(this.KEY_COOKIE);

            this.easy_json.patch(undefined);

            if (this.listOfConsents || this.webhookUrl) {
                const { ip } = await this.getIP();
                this.ip = ip;
            }

            if (this.webhookUrl) {
                this.sendWebhook({
                    action: "revoke",
                    navigator: navigator.userAgent,
                    ip: this.ip,
                    ...this.cookieStatus,
                });
            }

            if (this.listOfConsents) {
                try {
                    await this.saveToList({
                        action: "revoke",
                        consentId: this.consentId,
                        ...this.cookieStatus,
                    });
                } catch (e) {
                    console.error(e);
                }
            }

            const revokeUrl = `${this.clientUrl}/cookie/revoke/${this.cookieId}?origin=${
                window.location.origin
            }${this.consentId ? `&consentId=${this.consentId}` : ""}`;

            window.open(revokeUrl, "_blank");

            window.location.reload();
        }

        async changeCookies(e) {
            e.preventDefault();

            const savedCookieStatus = this.readLsAndEj(this.KEY_COOKIE);
            if (savedCookieStatus == undefined) {
                return;
            }

            this.cookie = document.createElement("div");
            this.adjust = document.createElement("div");
            this.fontLink = document.createElement("link");

            this.appendCookie(true);
        }

        allowLink(link) {
            const newLink = link.cloneNode();
            newLink.type = "text/javascript";
            newLink.innerText = link.innerText;
            link.parentNode.insertBefore(newLink, link);
            link.remove();
        }

        blockLink(link) {
            link.remove();
        }

        sendWebhook(data) {
            const dataToSent = data;
            dataToSent.location = window.location.href;

            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", this.webhookUrl, true);
            xhttp.setRequestHeader("Content-type", "application/json");
            xhttp.send(JSON.stringify(dataToSent));
        }

        saveToList(data) {
            return new Promise((resolve, reject) => {
                const appHostname = new URL(this.origin).hostname;
                const url = window.location.hostname;
                if (!url || url === appHostname) {
                    return false;
                }
                const xhttp = new XMLHttpRequest();
                xhttp.open("POST", `${this.origin}/api/cookies/${this.cookieId}/consent`, !0);
                xhttp.setRequestHeader("Content-type", "application/json");

                xhttp.send(JSON.stringify(data));
                xhttp.onreadystatechange = function () {
                    if (this.readyState === 4) {
                        if (this.status === 201) {
                            resolve(this.responseText);
                        } else {
                            reject(false);
                        }
                    }
                };
            });
        }

        getIP() {
            return fetch(`${this.origin}/api/cookies/ip`, { mode: "cors" }).then((resp) =>
                resp.json()
            );
        }

        readLsAndEj(key) {
            if (window.easyJSON && window.easyJSON[key]) {
                const value = window.easyJSON[key];
                //update localStorage in case they are different
                localStorage.setItem(key, value);
                return JSON.parse(value);
            }
            return JSON.parse(localStorage.getItem(key));
        }

        saveLsAndEj(key, value) {
            const obj = {};
            obj[key] = JSON.stringify(value);
            localStorage.setItem(key, obj[key]);
            this.easy_json.patch(obj);
        }

        sendStats() {
            const appHostname = new URL(this.origin).hostname;
            const url = window.location.hostname;
            if (!url || url === appHostname) {
                return false;
            }
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", `${this.origin}/api/stats`, true),
                xhttp.setRequestHeader("Content-type", "application/json"),
                xhttp.send(
                    JSON.stringify({
                        cookieId: this.cookieId,
                        type: "cookie",
                        url: window.location.href,
                        uuid: undefined, // todo uuid for stats.
                    })
                );
        }
    }

    function startEasyCookie() {
        new Cookies(
            "fontNameToReplace",
            "cookieHtmlToReplace",
            "adjustHtmlToReplace",
            "webhookUrlToReplace",
            "cookieIdToReplace",
            "originToReplace",
            "clientUrlToReplace",
            "listOfConsentsToReplace",
            "sendToGtmToReplace"
        );
    }

    if (document.readyState !== "loading") {
        startEasyCookie();
    } else {
        document.addEventListener("DOMContentLoaded", startEasyCookie);
    }
};
